import { render } from "./AuthStep2.vue?vue&type=template&id=013680c6&scoped=true"
import script from "./AuthStep2.vue?vue&type=script&lang=js"
export * from "./AuthStep2.vue?vue&type=script&lang=js"

import "./AuthStep2.vue?vue&type=style&index=0&id=013680c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013680c6"]])

export default __exports__